import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_ERROR'
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_ERROR = 'DELETE_CATEGORY_ERROR'
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_ERROR = 'UPDATE_CATEGORY_ERROR'
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS'
export const SELECT_CATEGORY = 'SELECT_CATEGORY'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectCategory(category) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_CATEGORY,
      payload: category
    })
  }
}

// ------------------------------------
// Basic Actions
// ------------------------------------
export function reorderCategories(orderedCategories) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    let fanoutObject = {}
    let counter = 1
    orderedCategories.forEach(c => {
      fanoutObject['/categories/' + c.key + '/order'] = counter
      counter++
    })
    firebase.update(fanoutObject)
  }
}
export function createCategory({ name, color, tva }) {
  return (dispatch, getState) => {
    const { firebase, categories, auth } = getState()
    let nextOrder = 0
    categories.list.forEach(cat => {
      if (nextOrder < cat.order) {
        nextOrder = cat.order
      }
    })
    nextOrder++
    const now = moment().format()
    const category = {
      createdBy: auth.hbUserKey,
      updatedBy: auth.hbUserKey,
      createdAt: now,
      updatedAt: now,
      productsCounter: 0,
      name: name,
      color: color,
      tva: tva,
      order: nextOrder
    }
    firebase.child('categories').push(category, error => {
      if (error) {
        console.error('ERROR @ createCATEGORY :', error)
        dispatch({
          type: CREATE_CATEGORY_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteCategories(categoriesDel) {
  return (dispatch, getState) => {
    const { firebase, categories } = getState()
    categoriesDel = _.isArray(categoriesDel) ? categoriesDel : [categoriesDel]
    let fanout = {}
    let counter = 1
    categories.list.forEach(cat => {
      if (
        !categoriesDel.find(e => e.key === cat.key && e.order === cat.order)
      ) {
        fanout['/categories/' + cat.key + '/order'] = counter
        counter++
      } else {
        fanout['/categories/' + cat.key] = null
      }
    })
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ deleteCategory :', error)
        dispatch({
          type: DELETE_CATEGORY_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateCategory(category, changes) {
  return (dispatch, getState) => {
    const { firebase, auth } = getState()
    changes.updatedBy = auth.hbUserKey
    changes.updatedAt = moment().format()
    firebase.child('categories/' + category.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateCategory :', error)
        dispatch({
          type: UPDATE_CATEGORY_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerCategoriesListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('categories').orderByChild('order')

    ref.on('child_added', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_CATEGORY_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_changed', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: UPDATE_CATEGORY_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_CATEGORY_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createCategory,
  updateCategory,
  registerCategoriesListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_CATEGORY_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(category => category.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_CATEGORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_CATEGORY_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(category => {
        return category.key === action.payload.key ? action.payload : category
      })
    }),
  [UPDATE_CATEGORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_CATEGORY_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(category => {
        return category.key !== action.payload.key
      })
    }),
  [DELETE_CATEGORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CATEGORY]: (state, action) =>
    Object.assign({}, state, { selectedCategory: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedCategory: {} }
export default function tableReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/category.js